import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/fhq-help-contacts';
import { IdType, ResultState } from '@rootCommon/types/common';
import { FhqHelpContact } from '@rootCommon/types/fhq';

type Action = ActionType<typeof actions>;
export type FhqHelpContactsState = ResultState<{ siteFhqId: IdType; items: FhqHelpContact[] }[] | null>;

const initState: FhqHelpContactsState = {
  data: null,
  loading: false,
  error: null,
};

export const fhqHelpContactsReducer = (state = initState, action: Action): FhqHelpContactsState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchFhqHelpContacts.request):
      return { ...state, loading: true };
    case getType(actions.fetchFhqHelpContacts.success):
      return { ...state, loading: false, data: [...(state.data || []), action.payload] };
    case getType(actions.fetchFhqHelpContacts.failure):
      return { ...state, loading: false, error: action.payload };

      // create
    case getType(actions.createFhqHelpContact.request):
      return { ...state, loading: true, error: null };
    case getType(actions.createFhqHelpContact.success):
      return {
        ...state,
        loading: false,
        data:
          state.data?.map((item) => (item.siteFhqId === action.payload.siteFhqId
            ? { siteFhqId: item.siteFhqId, items: [...item.items, action.payload.data] }
            : item)) || null,
      };
    case getType(actions.createFhqHelpContact.failure):
      return { ...state, loading: false, error: action.payload };

      // update
    case getType(actions.updateFhqHelpContact.request):
      return { ...state, loading: true };
    case getType(actions.updateFhqHelpContact.success):
      return {
        ...state,
        loading: false,
        data:
          state.data?.map((item) => (item.siteFhqId === action.payload.siteFhqId
            ? {
              siteFhqId: item.siteFhqId,
              items: item.items.map((item) => (item.id === action.payload.data.id ? action.payload.data : item)),
            }
            : item)) || null,
      };
    case getType(actions.updateFhqHelpContact.failure):
      return { ...state, loading: false, error: action.payload };

      // delete
    case getType(actions.deleteFhqHelpContact.request):
      return { ...state, loading: true };
    case getType(actions.deleteFhqHelpContact.success):
      return {
        ...state,
        loading: false,
        data:
                    state.data?.map((item) => ({
                      siteFhqId: item.siteFhqId,
                      items: item.items.filter((item) => item.id !== action.payload) || null,
                    })) || null,
      };
    case getType(actions.deleteFhqHelpContact.failure):
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default fhqHelpContactsReducer;
